"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderRowFilters = void 0;
const _ = __importStar(require("lodash"));
const helpers_1 = require("../helpers");
const slickgrid_1 = require("slickgrid");
class HeaderRowFilters {
    pluginName = 'HeaderRowFilters';
    _grid;
    _handler = new slickgrid_1.SlickEventHandler();
    filters = {};
    unsubscribeAll;
    onColumnFilterChange = new slickgrid_1.SlickEvent();
    getOptions() {
        return {
            showHeaderRow: true,
            headerRowHeight: 28
        };
    }
    init(grid) {
        this._grid = grid;
        this._handler.subscribe(this._grid.onHeaderRowCellRendered, this.onHeaderRowCellRendered.bind(this));
        const handleInputChange = _.throttle(_.partial(onInputChange, this), 300);
        const handleSearch = _.throttle(_.partial(onSearch, this), 300);
        const hr = grid.getHeaderRow();
        for (let el of Array.isArray(hr) ? hr : [hr]) {
            el.addEventListener('change', handleInputChange);
            el.addEventListener('keyup', handleInputChange);
            el.addEventListener('search', handleSearch);
        }
        this.unsubscribeAll = () => {
            const hr = grid.getHeaderRow();
            for (let el of Array.isArray(hr) ? hr : [hr]) {
                el.removeEventListener('change', handleInputChange);
                el.removeEventListener('keyup', handleInputChange);
                el.removeEventListener('search', handleSearch);
            }
        };
    }
    destroy() {
        this._handler.unsubscribeAll();
        this.unsubscribeAll();
    }
    onChange(columnId, newValue, notify, element) {
        newValue = newValue.trim();
        const previousFilters = _.clone(this.filters);
        this.filters[columnId] = newValue;
        if ((0, helpers_1.isEmpty)(newValue)) {
            element.classList.remove('has-value');
        }
        else {
            element.classList.add('has-value');
        }
        if (notify) {
            const filters = _.clone(this.filters);
            this.onColumnFilterChange.notify({ filters, previousFilters });
        }
    }
    onHeaderRowCellRendered(e) {
        const args = e.getArguments();
        if (!args || !args.column.filterable) {
            return;
        }
        const columnId = args.column.id;
        const inputValue = this.filters[columnId];
        const className = ['column-filter'];
        if (!(0, helpers_1.isEmpty)(inputValue)) {
            className.push('has-value');
        }
        slickgrid_1.Utils.emptyElement(args.node);
        let el = slickgrid_1.Utils.createDomElement('input', {
            type: 'search',
            className: className.join(' ')
        });
        el.dataset['columnId'] = columnId;
        if (!(0, helpers_1.isEmpty)(inputValue)) {
            el.value = inputValue;
        }
        args.node.appendChild(el);
    }
}
exports.HeaderRowFilters = HeaderRowFilters;
function onInputChange(self, e) {
    if (e.target instanceof HTMLInputElement) {
        const newValue = _.trim(e.target.value);
        const columnId = e.target.dataset['columnId'];
        if (columnId) {
            self.onChange(columnId, newValue, true, e.target);
        }
    }
}
function onSearch(self, e) {
    if (e.target instanceof HTMLInputElement) {
        const newValue = _.trim(e.target.value);
        const columnId = e.target.dataset['columnId'];
        if (columnId && newValue === '') {
            self.onChange(columnId, newValue, true, e.target);
        }
    }
}
//# sourceMappingURL=HeaderRowFilters.js.map